import actionTypes from '../actionTypes';

export function requestAvatarMenu() {
  return {
    type: actionTypes.AVATAR_MENU_REQUEST
  };
}

export function successAvatarMenu(menu) {
  return {
    type: actionTypes.AVATAR_MENU_SUCCESS,
    menu
  };
}

export function requestSetAvatar({ name, imagePath }) {
  return {
    type: actionTypes.SET_PROFILE_AVATAR_REQUEST,
    name,
    imagePath
  };
}

export function successSetAvatar({accountId}) {
  return {
    type: actionTypes.SET_PROFILE_AVATAR_SUCCESS,
    accountId
  };
}

export function failureSetAvatar() {
  return {
    type: actionTypes.SET_PROFILE_AVATAR_FAILURE
  };
}


export function requestAvatars( accountList ) {
  return {
    type: actionTypes.AVATARS_REQUEST,
    accountList
  };
}

export function successAvatars( avatars ) {
  return {
    type: actionTypes.AVATARS_SUCCESS,
    avatars
  };
}

export const avatarJSONSuccess = (path, json) => ({
  type: actionTypes.AVATAR_JSON_SUCCESS,
  path, json,
});

export const avatarJSONFailure = (path, e) => ({
  type: actionTypes.AVATAR_JSON_FAILURE,
  path,
  exception: e,
});
